export const LoadingSpinner = ({ size = 'md', text }) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
  };

  return (
    <div className="flex flex-col items-center justify-center py-12" data-testid="loading-spinner">
      <div
        className={`animate-spin rounded-full border-t-slate-900 border-r-slate-900 border-b-transparent border-l-transparent ${sizeClasses[size]}`}
      />
      {text && <p className="mt-4 text-sm text-stone-600">{text}</p>}
    </div>
  );
};